export default __webpack_public_path__ + "static/media/surveyThanks.4c4a88dc.svg";